function Title({ title, className = "" }) {
  return (
    <h2 className={`font-bold text-3xl md:text-4xl text-ink tracking-tight ${className}`.trim()}>
      {title}
    </h2>
  );
}

export default Title;
